export const customerProfileKeys = {
  all: ['customer-profile'] as const,
  profile: () => [...customerProfileKeys.all, 'profile'] as const,
  consents: () => [...customerProfileKeys.all, 'consents'] as const,
  consentHistory: (params: { limit?: number; cursor?: string } = {}) =>
    [...customerProfileKeys.consents(), params] as const,
};
